import styled from "@emotion/styled";
import { Select, Space } from "antd";

export const ModalFields = styled(Space)`
  width: 100%;
`;

export const FullWidthSelect = styled(Select)`
  width: 100%;
`;
